import Service from "./Service";

export default class Item {
	itemTypeId: string;
	itemId: string;
	id: string;
	name: string;
	count: number;
	status: string;
	services: Array<Service>;

	constructor() {
		this.services = new Array<Service>();
	}
}
